function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTr2TogL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10.880112mm",
    height: "20.051638mm",
    viewBox: "0 0 10.880112 20.051638",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-102.10145,-104.24656)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M 105.10776,123.80522 V 104.7669 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 112.48405,123.74676 -7.30558,-19.00675 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.999999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 102.59443,112.35067 h 9.0524 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.999999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 102.59443,114.77982 h 9.0524 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr2TogL);
export default __webpack_public_path__ + "static/media/tr2tog-l.b3e17611b56fcf659c50043e02312622.svg";
export { ForwardRef as ReactComponent };